import {Control, FieldPath, FieldValues} from "react-hook-form";
import {
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@root/server/client/esweb/components/ui/form.tsx";
import {Input} from "@root/server/client/esweb/components/ui/input.tsx";

interface FormInputProps<T extends FieldValues> extends React.ComponentProps<"input"> {
  // Update this line: Allow Control<any> to bypass the strict variance check
  control: Control<T> | Control<any>;
  name: FieldPath<T>; // Use FieldPath (better than Path in newer RHF)
  label?: string;
  description?: string;
}

export const FormInput = <T extends FieldValues>({
  control,
  name,
  label,
  description,
  ...props
}: FormInputProps<T>) => {
  return (
    <FormField
      // Cast control back to Control<T> for the internal FormField
      control={control as Control<T>}
      name={name}
      render={({ field }) => (
        <FormItem>
          {label && <FormLabel>{label}</FormLabel>}
          <FormControl>
            <Input {...props} {...field} />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
